import Enum from './enum'

class RetendState extends Enum
{
  constructor(value) {
    super(value);
  }
}

RetendState.init({
  NONE: 'None',
  DRAFT: 'Draft',
  REGISTERED: 'Registred',
  CLOSED: 'Closed',
  DECLINED: 'Declined'
}, {
  NONE: 'retend-state.empty',
  DRAFT: 'retend-state.draft',
  REGISTERED: 'retend-state.registered',
  CLOSED: 'retend-state.closed',
  DECLINED: 'retend-state.declined'
});

export default RetendState;
